"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateEventVersion = exports.buildConsentLabel = exports.BuilderConfigStatuses = exports.SweepstakesRulesTypes = exports.PostShowEmailCTATypes = exports.PostShowEmailTypes = exports.PolicyEntities = exports.PostRegistationOptions = exports.VoteTypeOptions = exports.CheckInVoteOptions = exports.Languages = exports.isNonSonyTerritory = exports.coveredSonyCountryCodes = exports.venueCountryCode = exports.getSocialLinks = exports.StreamingServiceNames = exports.generatePostRegText = exports.generatePreRegText = void 0;
const event_1 = require("../event");
const utils_1 = require("../utils");
const postregistration_1 = require("./postregistration");
const preregistration_1 = require("./preregistration");
const privacy_1 = require("./privacy");
const colors_1 = require("./colors");
const sony_1 = require("./sony");
const generateBuilderConfig_1 = require("./generateBuilderConfig");
var preregistration_2 = require("./preregistration");
Object.defineProperty(exports, "generatePreRegText", { enumerable: true, get: function () { return preregistration_2.generatePreRegText; } });
var postregistration_2 = require("./postregistration");
Object.defineProperty(exports, "generatePostRegText", { enumerable: true, get: function () { return postregistration_2.generatePostRegText; } });
__exportStar(require("./generateCustomFields"), exports);
__exportStar(require("./colors"), exports);
__exportStar(require("./generateBuilderConfig"), exports);
__exportStar(require("./privacy"), exports);
__exportStar(require("./default-fields"), exports);
// From spotify
/**
 * - album
 * - single
 * - appears_on (ignore??)
 * - compilation (ignore??)
 */
exports.StreamingServiceNames = [
    { path: "appleMusic", name: "Apple Music" },
    { path: "amazon", name: "Amazon Music" },
    { path: "pandora", name: "Pandora" },
    { path: "spotify", name: "Spotify" },
    { path: "youtubeMusic", name: "YouTube Music" },
    { path: "deezer", name: "Deezer" },
    { path: "iHeartRadio", name: "iHeartRadio" },
    { path: "tidal", name: "Tidal" },
];
/**
 * Extracts social links from bulder config doc.
 */
const getSocialLinks = (config) => {
    const getSocialKey = (key) => {
        var _a;
        const { name } = ((_a = key.match(/socialLink(?<name>.*)/)) === null || _a === void 0 ? void 0 : _a.groups) || {};
        if (name) {
            if (event_1.SocialLinkNames.includes(name.toLowerCase())) {
                return name.toLowerCase();
            }
        }
    };
    return Object.fromEntries(Object.entries(config.fields || {})
        .map(([key, value]) => {
        const k = getSocialKey(key);
        if (k && typeof value.content === "string") {
            return [k, value.content];
        }
        return undefined;
    })
        .filter(utils_1.filterUndefined));
};
exports.getSocialLinks = getSocialLinks;
/**
 * ISO alpha-2 country code of a concert's venue.
 *
 * Imported (e.g. AME) shows arrive with an ISO code already in `country` but no
 * geocode; manually-added shows carry a full country name plus a geocode. Prefer
 * the ISO code when `country` is already two letters, otherwise fall back to the
 * geocode's country `short_name`. Shared by the builder preview (client) and
 * publish (server) so both resolve the venue country identically.
 */
const venueCountryCode = (concert) => {
    var _a, _b, _c, _d, _e;
    const country = (_a = concert === null || concert === void 0 ? void 0 : concert.country) === null || _a === void 0 ? void 0 : _a.trim();
    if (country && /^[A-Za-z]{2}$/.test(country))
        return country.toUpperCase();
    return (_e = (_d = (_c = (_b = concert === null || concert === void 0 ? void 0 : concert.geocode) === null || _b === void 0 ? void 0 : _b.address_components) === null || _c === void 0 ? void 0 : _c.find((c) => c.types.includes("country"))) === null || _d === void 0 ? void 0 : _d.short_name) === null || _e === void 0 ? void 0 : _e.toUpperCase();
};
exports.venueCountryCode = venueCountryCode;
/**
 * Builds the covered-country-code set (upper-cased) from the
 * `sony_music_country_optins` docs. Kept here so every caller normalizes codes
 * identically to {@link venueCountryCode}.
 */
const coveredSonyCountryCodes = (optIns) => new Set((optIns !== null && optIns !== void 0 ? optIns : []).map((o) => o.countryCode.toUpperCase()));
exports.coveredSonyCountryCodes = coveredSonyCountryCodes;
/**
 * True when Sony is enabled for the artist and the venue's country is NOT a
 * covered Sony territory — i.e. the Sony opt-in (and the "sony" record label)
 * will be dropped for this show. False when Sony is off/not loaded or the
 * country can't be resolved (unknown ≠ warn). Mirror of the server-side gate in
 * `getSonyOptInForEvent`, so the warning matches what actually gets injected.
 */
const isNonSonyTerritory = (concert, status) => {
    // Don't warn until we actually know the covered set — an unloaded (empty) set
    // would make every venue look uncovered.
    if (!status.ready)
        return false;
    const code = (0, exports.venueCountryCode)(concert);
    return !!code && !status.coveredCountryCodes.has(code);
};
exports.isNonSonyTerritory = isNonSonyTerritory;
exports.Languages = {
    es: "Spanish",
    fr: "French",
    de: "German",
    pt: "Portuguese",
};
exports.CheckInVoteOptions = ["checkin", "vote"];
exports.VoteTypeOptions = ["song", "vote"];
exports.PostRegistationOptions = ["thank", "promo", "link"];
exports.PolicyEntities = [
    { path: "artist", name: "Artist" },
    { path: "management", name: "Management" },
    { path: "recordLabel", name: "Record Label" },
    { path: "marketing", name: "Marketing" },
    { path: "other", name: "Other" },
];
exports.PostShowEmailTypes = [
    "disabled",
    "default",
    "custom",
    "html",
];
exports.PostShowEmailCTATypes = ["survey", "custom", "disabled"];
exports.SweepstakesRulesTypes = [
    "default",
    "link",
    "html",
    "custom",
];
exports.BuilderConfigStatuses = [
    "created",
    "draft",
    "publish_requested",
    "published",
];
/**
 * Check to see if the provided object is a Luxon DateTime instance.
 */
const isDateTime = (maybeDateTime) => {
    const d = Object.getOwnPropertyDescriptor(maybeDateTime, "isLuxonDateTime");
    return (d === null || d === void 0 ? void 0 : d.value) === true;
};
/**
 * Build the consent label from artist data, matching the migration script format.
 * Uses privacy policies for names + URLs, falling back to artistName.
 */
const consentLabelTemplates = {
    en: "I'd like to receive all the latest via email from {artists} — new releases, shows, pre-sales, news and more.",
    es: "Me gustaría recibir todas las novedades por correo electrónico de {artists} — nuevos lanzamientos, shows, preventas, noticias y más.",
    fr: "J'aimerais recevoir toutes les dernières nouvelles par e-mail de {artists} — nouvelles sorties, spectacles, préventes, actualités et plus encore.",
    de: "Ich möchte alle Neuigkeiten per E-Mail von {artists} erhalten — neue Veröffentlichungen, Shows, Vorverkäufe, Nachrichten und mehr.",
};
const buildConsentLabel = (artistName, privacyPolicies, language = "en") => {
    var _a, _b, _c;
    const template = (_a = consentLabelTemplates[language]) !== null && _a !== void 0 ? _a : consentLabelTemplates.en;
    const conjunction = (_b = privacy_1.properNounConjunction[language]) !== null && _b !== void 0 ? _b : privacy_1.properNounConjunction.en;
    const policies = (_c = privacyPolicies === null || privacyPolicies === void 0 ? void 0 : privacyPolicies.filter((p) => p.name)) !== null && _c !== void 0 ? _c : [];
    const artistNames = policies.length > 0
        ? policies.map((p) => p.url ? `<a href="${p.url}" target="_blank">${p.name}</a>` : p.name)
        : artistName
            ? [artistName]
            : [];
    if (artistNames.length === 0)
        return "";
    const formatted = artistNames.length > 1
        ? artistNames.slice(0, -1).join(", ") +
            ` ${conjunction} ` +
            artistNames[artistNames.length - 1]
        : artistNames[0];
    return template.replace("{artists}", formatted);
};
exports.buildConsentLabel = buildConsentLabel;
/**
 * Generate a SETLive fan config document.
 */
const generateEventVersion = (config, { language = "en", demoConfig, props, Timestamp, sonyOptIn, }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56, _57, _58, _59, _60, _61, _62, _63, _64, _65, _66, _67, _68, _69, _70, _71, _72, _73, _74, _75, _76, _77, _78, _79, _80, _81, _82, _83, _84, _85, _86, _87, _88, _89, _90, _91, _92, _93, _94, _95, _96, _97, _98, _99, _100, _101, _102, _103, _104, _105, _106, _107, _108, _109, _110, _111, _112, _113, _114, _115, _116, _117, _118, _119, _120, _121, _122, _123, _124, _125, _126, _127, _128, _129, _130, _131, _132;
    const postRegText = (0, postregistration_1.generatePostRegText)(config);
    const { preRegText } = (0, preregistration_1.generatePreRegText)(config);
    //
    // TODO: Make translatable
    //
    const { sms, terms, separateTerms } = (0, privacy_1.generatePrivacyText)(config, language);
    const getTimestamp = (dateThingy) => {
        if (isDateTime(dateThingy)) {
            return Timestamp.fromDate(dateThingy.toJSDate());
        }
        return dateThingy;
    };
    const disableDefaultCopy = !!(props === null || props === void 0 ? void 0 : props.override.disableDefaultCopy);
    const image = ((_b = (_a = config === null || config === void 0 ? void 0 : config.fields) === null || _a === void 0 ? void 0 : _a.image) === null || _b === void 0 ? void 0 : _b.content) ||
        ((_d = (_c = config === null || config === void 0 ? void 0 : config.images) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.src) ||
        (demoConfig === null || demoConfig === void 0 ? void 0 : demoConfig.header.image);
    const { imageColors, imageIndex } = (0, colors_1.getColorConfig)(config);
    const date = ((_f = (_e = config.fields) === null || _e === void 0 ? void 0 : _e.startTime) === null || _f === void 0 ? void 0 : _f.content)
        ? getTimestamp(config.fields.startTime.content)
        : demoConfig === null || demoConfig === void 0 ? void 0 : demoConfig.header.date;
    const type = ((_g = props === null || props === void 0 ? void 0 : props.override) === null || _g === void 0 ? void 0 : _g.type) !== undefined
        ? (_h = props === null || props === void 0 ? void 0 : props.override) === null || _h === void 0 ? void 0 : _h.type
        : ((_k = (_j = config.fields) === null || _j === void 0 ? void 0 : _j.type) === null || _k === void 0 ? void 0 : _k.content) || 0;
    const colors = ((_l = props === null || props === void 0 ? void 0 : props.override) === null || _l === void 0 ? void 0 : _l.colors) ||
        ((_q = (_p = (_o = (_m = config.fields) === null || _m === void 0 ? void 0 : _m.colors) === null || _o === void 0 ? void 0 : _o.content) === null || _p === void 0 ? void 0 : _p[imageIndex]) === null || _q === void 0 ? void 0 : _q[type]) ||
        ((_r = imageColors === null || imageColors === void 0 ? void 0 : imageColors[type]) === null || _r === void 0 ? void 0 : _r[0]);
    if (!config.fields ||
        ((_t = (_s = config.fields) === null || _s === void 0 ? void 0 : _s.type) === null || _t === void 0 ? void 0 : _t.content) === undefined ||
        !image ||
        !date ||
        !colors) {
        throw new Error("TODO: Handle this");
    }
    if (disableDefaultCopy) {
        preRegText.headline = "";
        preRegText.subtitle = "";
        preRegText.body = "";
        postRegText.headline = "";
        postRegText.body = "";
    }
    const optionalSms = ((_v = (_u = config.customRegister) === null || _u === void 0 ? void 0 : _u[language]) === null || _v === void 0 ? void 0 : _v.optionalSms) ||
        !!((_w = config.fields.makeTextMessageOptInOptional) === null || _w === void 0 ? void 0 : _w.content);
    const optionalPhone = ((_y = (_x = config.customRegister) === null || _x === void 0 ? void 0 : _x[language]) === null || _y === void 0 ? void 0 : _y.optionalPhone) ||
        !!((_z = config.fields.makePhoneNumberFieldOptional) === null || _z === void 0 ? void 0 : _z.content);
    // customTerms / customAgreement / customSweepstakesRules / sweepstakesDisclaimer
    // / sweepstakesRulesLabel are derived from their respective toggles
    // (useCustomTermsAndPrivacyPolicy, sweepstakes). Strip them off customRegister
    // before spreading so the conditional overrides below fully control their
    // presence — otherwise stale values round-tripped from the last published event
    // (via generateBuilderConfig.ts copying event.config.register into
    // config.customRegister.en) leak through when a toggle is turned off.
    const persistedRegister = { ...((_1 = (_0 = config.customRegister) === null || _0 === void 0 ? void 0 : _0[language]) !== null && _1 !== void 0 ? _1 : {}) };
    delete persistedRegister.customTerms;
    delete persistedRegister.customAgreement;
    delete persistedRegister.customSweepstakesRules;
    delete persistedRegister.sweepstakesDisclaimer;
    delete persistedRegister.sweepstakesRulesLabel;
    const register = {
        ...demoConfig === null || demoConfig === void 0 ? void 0 : demoConfig.register,
        ...persistedRegister,
        title: (_3 = (_2 = config.fields.registerTitle) === null || _2 === void 0 ? void 0 : _2.content) === null || _3 === void 0 ? void 0 : _3[language],
        subtitle: (_5 = (_4 = config.fields.registerSubtitle) === null || _4 === void 0 ? void 0 : _4.content) === null || _5 === void 0 ? void 0 : _5[language],
        ctalabel: ((_7 = (_6 = config.fields.registerCtaLabel) === null || _6 === void 0 ? void 0 : _6.content) === null || _7 === void 0 ? void 0 : _7[language]) ||
            (((_9 = (_8 = config === null || config === void 0 ? void 0 : config.fields) === null || _8 === void 0 ? void 0 : _8.checkInVote) === null || _9 === void 0 ? void 0 : _9.content) === "vote" ? "Vote" : "Check In"),
        sms,
        terms,
        ...(!((_10 = config.fields.useCustomTermsAndPrivacyPolicy) === null || _10 === void 0 ? void 0 : _10.content)
            ? {
                ...(!!(separateTerms === null || separateTerms === void 0 ? void 0 : separateTerms.length) && {
                    customTerms: separateTerms[0],
                }),
                ...((separateTerms === null || separateTerms === void 0 ? void 0 : separateTerms.length) &&
                    separateTerms.length > 1 && {
                    customAgreement: separateTerms[1],
                }),
            }
            : {
                terms: (_12 = (_11 = config.fields.customTermsAndPrivacyPolicy) === null || _11 === void 0 ? void 0 : _11.content) === null || _12 === void 0 ? void 0 : _12[language],
                customTerms: (_14 = (_13 = config.fields.separateLineTermsAndPrivacyPolicy) === null || _13 === void 0 ? void 0 : _13.content) === null || _14 === void 0 ? void 0 : _14[language],
            }),
        ...(((_15 = config.fields.useCustomSMSOptIn) === null || _15 === void 0 ? void 0 : _15.content) && {
            sms: (_17 = (_16 = config.fields.customSMSOptIn) === null || _16 === void 0 ? void 0 : _16.content) === null || _17 === void 0 ? void 0 : _17[language],
        }),
        hasSweepstakes: (_18 = config.fields.sweepstakes) === null || _18 === void 0 ? void 0 : _18.content,
        optionalSms,
        optionalPhone,
    };
    if ((_19 = config.fields.sweepstakes) === null || _19 === void 0 ? void 0 : _19.content) {
        const rulesType = (_20 = config.fields.sweepstakesRulesType) === null || _20 === void 0 ? void 0 : _20.content;
        switch (rulesType) {
            case "html":
                register.customSweepstakesRules =
                    (_22 = (_21 = config.fields.sweepstakesRulesHtml) === null || _21 === void 0 ? void 0 : _21.content) === null || _22 === void 0 ? void 0 : _22[language];
                break;
            case "link":
                register.customSweepstakesRules =
                    (process.env.REACT_APP_RULES_URL || "https://rules.set.live") +
                        `/${(_24 = (_23 = config.fields.sweepstakesRulesLink) === null || _23 === void 0 ? void 0 : _23.content) === null || _24 === void 0 ? void 0 : _24[language]}`;
                break;
            case "custom":
                register.customSweepstakesRules =
                    (_26 = (_25 = config.fields.sweepstakesRulesCustomUrl) === null || _25 === void 0 ? void 0 : _25.content) === null || _26 === void 0 ? void 0 : _26[language];
                break;
            case "default":
            default:
                register.customSweepstakesRules = "";
                break;
        }
        // The disclaimer + rules label describe *custom* rules, so choosing SET's
        // default rules restores the fan app's built-in wording. The values stay in
        // the builder config, so switching back to custom rules restores them too.
        //
        // Both are also optional on their own: an empty value means "keep the
        // default", so don't publish a key the fan app would read as a deliberate
        // blank.
        if (rulesType && rulesType !== "default") {
            const disclaimer = (_28 = (_27 = config.fields.sweepstakesDisclaimer) === null || _27 === void 0 ? void 0 : _27.content) === null || _28 === void 0 ? void 0 : _28[language];
            if (disclaimer) {
                register.sweepstakesDisclaimer = disclaimer;
            }
            const rulesLabel = (_30 = (_29 = config.fields.sweepstakesRulesLabel) === null || _29 === void 0 ? void 0 : _29.content) === null || _30 === void 0 ? void 0 : _30[language];
            if (rulesLabel) {
                register.sweepstakesRulesLabel = rulesLabel;
            }
        }
    }
    // Consent is derived from the useCustomConsent toggle, but its *placement* in
    // the form belongs to the user's `fieldsOrder`. We re-derive the consent entry
    // (so its label stays fresh) without clobbering a user-chosen order.
    //
    // Stale consent can be pre-seeded into `customRegister` via the
    // addCustomConsentFieldToEvents migration plus generateBuilderConfig copying
    // event.config.register back into config.customRegister.en, so we always strip
    // it first and re-add only when enabled.
    const reindex = (entries) => entries.map(({ id }, index) => ({ id, index }));
    const stripConsent = (entries) => entries.filter((f) => f.id !== event_1.CUSTOM_CONSENT_FIELD_ID);
    // Whether the user has already placed consent in their order (vs. it being
    // absent, or stale data we should reposition).
    const userPlacedConsent = !!((_31 = register.fieldsOrder) === null || _31 === void 0 ? void 0 : _31.some((f) => f.id === event_1.CUSTOM_CONSENT_FIELD_ID));
    // Strip the (possibly stale) consent entry from customFields; re-added below.
    if ((_32 = register.customFields) === null || _32 === void 0 ? void 0 : _32.length) {
        register.customFields = stripConsent(register.customFields);
        if (!register.customFields.length)
            delete register.customFields;
    }
    // Resolve the consent label only when enabled; a falsy label disables consent.
    const consentLabel = ((_33 = config.fields.useCustomConsent) === null || _33 === void 0 ? void 0 : _33.content)
        ? ((_35 = (_34 = config.fields.customConsentLabel) === null || _34 === void 0 ? void 0 : _34.content) === null || _35 === void 0 ? void 0 : _35[language]) ||
            (0, exports.buildConsentLabel)(config.artistName, (_36 = config.fields.privacyPolicies) === null || _36 === void 0 ? void 0 : _36.content, language)
        : undefined;
    if (!consentLabel) {
        // Disabled: drop any stale consent entry from the persisted order.
        if ((_37 = register.fieldsOrder) === null || _37 === void 0 ? void 0 : _37.length) {
            register.fieldsOrder = reindex(stripConsent(register.fieldsOrder));
            if (!register.fieldsOrder.length)
                delete register.fieldsOrder;
        }
    }
    else {
        // Replace age 13 → 18 in terms for Live Nation shows with custom consent.
        if (register.terms)
            register.terms = register.terms.replace("13", "18");
        register.customFields = [
            ...((_38 = register.customFields) !== null && _38 !== void 0 ? _38 : []),
            {
                id: event_1.CUSTOM_CONSENT_FIELD_ID,
                label: consentLabel,
                type: "checkbox",
                required: false,
            },
        ];
        const order = (_39 = register.fieldsOrder) !== null && _39 !== void 0 ? _39 : [];
        if (userPlacedConsent) {
            // Respect the position the user chose in the builder.
            register.fieldsOrder = reindex(order);
        }
        else {
            // Newly enabled: append consent to the end of the order so it matches how
            // the registration-fields sorting section lists a just-toggled-on field.
            // When there is no custom order yet, fall back to a [terms, sms?] base.
            const base = order.length
                ? order
                : [{ id: "terms" }, ...(register.sms ? [{ id: "sms" }] : [])];
            register.fieldsOrder = reindex([
                ...base,
                { id: event_1.CUSTOM_CONSENT_FIELD_ID },
            ]);
        }
    }
    // Sony Music opt-in (required, ordered between the email and SMS opt-ins). The
    // caller resolves it for the venue's country; we shape it here so the builder
    // preview and the published register stay identical. See ./sony.
    (0, sony_1.applySonyOptIn)(register, sonyOptIn, ((_40 = config.fields.displayedName) === null || _40 === void 0 ? void 0 : _40.content) || config.artistName || "");
    const fanConfig = {
        ...demoConfig,
        type,
        header: {
            ...demoConfig === null || demoConfig === void 0 ? void 0 : demoConfig.header,
            artistName: ((_42 = (_41 = config === null || config === void 0 ? void 0 : config.fields) === null || _41 === void 0 ? void 0 : _41.displayedName) === null || _42 === void 0 ? void 0 : _42.content) || config.artistName || "",
            date,
            image,
            venue: (_44 = (_43 = config.fields.concert) === null || _43 === void 0 ? void 0 : _43.content) === null || _44 === void 0 ? void 0 : _44.venue,
        },
        cards: [
            {
                cta: "register",
                visible: {
                    states: [event_1.UserEventStates.draft],
                },
                // Above the fold custom bodyHTML
                ...(((_46 = (_45 = config.fields.preRegistrationBodyHtml) === null || _45 === void 0 ? void 0 : _45.content) === null || _46 === void 0 ? void 0 : _46[language]) && {
                    bodyHtml: (_48 = (_47 = config.fields.preRegistrationBodyHtml) === null || _47 === void 0 ? void 0 : _47.content) === null || _48 === void 0 ? void 0 : _48[language],
                }),
                headline: ((_50 = (_49 = config.fields.preRegistrationHeadline) === null || _49 === void 0 ? void 0 : _49.content) === null || _50 === void 0 ? void 0 : _50[language]) ||
                    preRegText.headline,
                ...(((_51 = config.fields.checkInVote) === null || _51 === void 0 ? void 0 : _51.content) === "vote"
                    ? {
                        // Voting
                        tab: "Vote",
                        subtitle: ((_53 = (_52 = config.fields.preRegistrationSubtitle) === null || _52 === void 0 ? void 0 : _52.content) === null || _53 === void 0 ? void 0 : _53[language]) ||
                            preRegText.subtitle,
                        ...(((_54 = config.fields.voteType) === null || _54 === void 0 ? void 0 : _54.content) === "song"
                            ? {
                                // Songs
                                songs: (_57 = (_56 = (_55 = config.fields.songOptions) === null || _55 === void 0 ? void 0 : _55.content) === null || _56 === void 0 ? void 0 : _56.filter((song) => !!song.name)) === null || _57 === void 0 ? void 0 : _57.map((s) => ({
                                    id: s.name + s.album || "",
                                    title: s.name || "",
                                    album: s.album || "",
                                })),
                            }
                            : {
                                // Something else
                                songs: (_60 = (_59 = (_58 = config.fields.voteOptions) === null || _58 === void 0 ? void 0 : _58.content) === null || _59 === void 0 ? void 0 : _59.filter((option) => !!(option === null || option === void 0 ? void 0 : option[language]))) === null || _60 === void 0 ? void 0 : _60.map((s) => ({
                                    id: (s === null || s === void 0 ? void 0 : s[language]) || "",
                                    title: (s === null || s === void 0 ? void 0 : s[language]) || "",
                                })),
                            }),
                    }
                    : {
                        // Check In
                        tab: "Check In",
                        ctalabel: "Check In",
                        body: ((_62 = (_61 = config.fields.preRegistrationBody) === null || _61 === void 0 ? void 0 : _61.content) === null || _62 === void 0 ? void 0 : _62[language]) ||
                            preRegText.body,
                        ...(((_64 = (_63 = config.fields.preRegistrationButtonLabel) === null || _63 === void 0 ? void 0 : _63.content) === null || _64 === void 0 ? void 0 : _64[language]) && {
                            ctalabel: (_66 = (_65 = config.fields.preRegistrationButtonLabel) === null || _65 === void 0 ? void 0 : _65.content) === null || _66 === void 0 ? void 0 : _66[language],
                        }),
                    }),
            },
        ],
        colors: colors,
        register,
        social: {
            title: `${(_68 = (_67 = config.fields.postRegistrationButtonLabel) === null || _67 === void 0 ? void 0 : _67.content) === null || _68 === void 0 ? void 0 : _68[language]} ${(_70 = (_69 = config.fields.postRegistrationAlbum) === null || _69 === void 0 ? void 0 : _69.content) === null || _70 === void 0 ? void 0 : _70.name} on your favorite streaming service.`, //TODO: this should come from somewhere
            // subtitle: "available on:", this field not in use
            spotify: (_72 = (_71 = config.fields.postRegistrationAlbum) === null || _71 === void 0 ? void 0 : _71.content) === null || _72 === void 0 ? void 0 : _72.spotify,
            apple: (_74 = (_73 = config.fields.postRegistrationAlbum) === null || _73 === void 0 ? void 0 : _73.content) === null || _74 === void 0 ? void 0 : _74.appleMusic,
            amazon: (_76 = (_75 = config.fields.postRegistrationAlbum) === null || _75 === void 0 ? void 0 : _75.content) === null || _76 === void 0 ? void 0 : _76.amazon,
            deezer: (_78 = (_77 = config.fields.postRegistrationAlbum) === null || _77 === void 0 ? void 0 : _77.content) === null || _78 === void 0 ? void 0 : _78.deezer,
            youtube: (_80 = (_79 = config.fields.postRegistrationAlbum) === null || _79 === void 0 ? void 0 : _79.content) === null || _80 === void 0 ? void 0 : _80.youtubeMusic,
            pandora: (_82 = (_81 = config.fields.postRegistrationAlbum) === null || _81 === void 0 ? void 0 : _81.content) === null || _82 === void 0 ? void 0 : _82.pandora,
            tidal: (_84 = (_83 = config.fields.postRegistrationAlbum) === null || _83 === void 0 ? void 0 : _83.content) === null || _84 === void 0 ? void 0 : _84.tidal,
        },
        socialLinks: {
            facebook: (_85 = config.fields.socialLinkFacebook) === null || _85 === void 0 ? void 0 : _85.content,
            instagram: (_86 = config.fields.socialLinkInstagram) === null || _86 === void 0 ? void 0 : _86.content,
            tiktok: (_87 = config.fields.socialLinkTiktok) === null || _87 === void 0 ? void 0 : _87.content,
            spotify: (_88 = config.fields.socialLinkSpotify) === null || _88 === void 0 ? void 0 : _88.content,
            youtube: (_89 = config.fields.socialLinkYoutube) === null || _89 === void 0 ? void 0 : _89.content,
            twitter: (_90 = config.fields.socialLinkTwitter) === null || _90 === void 0 ? void 0 : _90.content,
            shazam: (_91 = config.fields.socialLinkShazam) === null || _91 === void 0 ? void 0 : _91.content,
        },
        ...(((_93 = (_92 = config.fields.footer) === null || _92 === void 0 ? void 0 : _92.content) === null || _93 === void 0 ? void 0 : _93.en) && {
            footer: (_95 = (_94 = config.fields.footer) === null || _94 === void 0 ? void 0 : _94.content) === null || _95 === void 0 ? void 0 : _95.en,
        }),
    };
    if (fanConfig.cards && ((_96 = config.fields.useCustomMainTabName) === null || _96 === void 0 ? void 0 : _96.content) === true) {
        fanConfig.cards[0].tab =
            (_98 = (_97 = config.fields.customMainTabName) === null || _97 === void 0 ? void 0 : _97.content) === null || _98 === void 0 ? void 0 : _98[language];
    }
    // Post registration view
    if (fanConfig.cards) {
        fanConfig.cards.push({
            tab: fanConfig.cards[0].tab,
            ...postRegText,
            headline: ((_100 = (_99 = config.fields.postRegistrationHeadline) === null || _99 === void 0 ? void 0 : _99.content) === null || _100 === void 0 ? void 0 : _100[language]) ||
                postRegText.headline,
            body: ((_102 = (_101 = config.fields.postRegistrationBody) === null || _101 === void 0 ? void 0 : _101.content) === null || _102 === void 0 ? void 0 : _102[language]) ||
                postRegText.body,
            // Below the fold custom body HTML
            ...(((_104 = (_103 = config.fields.postRegistrationBodyHtml) === null || _103 === void 0 ? void 0 : _103.content) === null || _104 === void 0 ? void 0 : _104[language]) && {
                bodyHtml: (_106 = (_105 = config.fields.postRegistrationBodyHtml) === null || _105 === void 0 ? void 0 : _105.content) === null || _106 === void 0 ? void 0 : _106[language],
            }),
            // Promote a Release
            ...(((_107 = config.fields.postRegistration) === null || _107 === void 0 ? void 0 : _107.content) === "promo" && {
                image: (_110 = (_109 = (_108 = config === null || config === void 0 ? void 0 : config.fields) === null || _108 === void 0 ? void 0 : _108.postRegistrationAlbum) === null || _109 === void 0 ? void 0 : _109.content) === null || _110 === void 0 ? void 0 : _110.image,
                ctalabel: ((_112 = (_111 = config.fields.postRegistrationButtonLabel) === null || _111 === void 0 ? void 0 : _111.content) === null || _112 === void 0 ? void 0 : _112[language]) ||
                    postRegText.ctalabel,
                cta: "social",
            }),
            // Custom Link
            ...(((_113 = config.fields.postRegistration) === null || _113 === void 0 ? void 0 : _113.content) === "link" && {
                cta: ((_114 = config.fields.postRegistrationLinkUrl) === null || _114 === void 0 ? void 0 : _114.content) || postRegText.cta,
                ctalabel: ((_116 = (_115 = config.fields.postRegistrationLinkLabel) === null || _115 === void 0 ? void 0 : _115.content) === null || _116 === void 0 ? void 0 : _116[language]) ||
                    postRegText.ctalabel,
            }),
            visible: {
                states: [event_1.UserEventStates.draft],
                hide: true,
            },
        });
    }
    // Merch View
    const merchTabName = !((_117 = config.fields.useCustomMerchTabName) === null || _117 === void 0 ? void 0 : _117.content)
        ? "Merch"
        : (_119 = (_118 = config.fields.customMerchTabName) === null || _118 === void 0 ? void 0 : _118.content) === null || _119 === void 0 ? void 0 : _119[language];
    if (!((_120 = config.fields.hideMerchandise) === null || _120 === void 0 ? void 0 : _120.content) &&
        !!((_122 = (_121 = config.fields.merchandise) === null || _121 === void 0 ? void 0 : _121.content) === null || _122 === void 0 ? void 0 : _122.length) &&
        fanConfig.cards) {
        fanConfig.cards.push({
            tab: merchTabName,
            ...(fanConfig.type === 0 && {
                headline: merchTabName,
                icon: "shirt",
            }),
            merch: (_124 = (_123 = config.fields.merchandise) === null || _123 === void 0 ? void 0 : _123.content) === null || _124 === void 0 ? void 0 : _124.reduce((acc, m) => {
                if (m.isSelected) {
                    acc.push({
                        ...m,
                        photo: m.img,
                        name: m.text,
                    });
                }
                return acc;
            }, []),
        });
    }
    // If swiper, add icons to pre & post registration cards
    if (fanConfig.type === 0 && fanConfig.cards) {
        fanConfig.cards[0].icon =
            ((_125 = config.fields.checkInVote) === null || _125 === void 0 ? void 0 : _125.content) === "vote" ? "checklist" : "user";
        fanConfig.cards[1].icon = "checkmark";
    }
    const country = (0, generateBuilderConfig_1.getAddressComponent)("country", (_128 = (_127 = (_126 = config.fields.concert) === null || _126 === void 0 ? void 0 : _126.content) === null || _127 === void 0 ? void 0 : _127.geocode) === null || _128 === void 0 ? void 0 : _128.address_components);
    if (!!country) {
        fanConfig.meta = {
            country: country,
        };
    }
    // Custom post show email 'from'
    if ((_129 = config.customPostShowEmail) === null || _129 === void 0 ? void 0 : _129.from) {
        fanConfig.customPostShowEmail = { ...config.customPostShowEmail };
    }
    // Light show looks, published unchanged to every language; titles and
    // subtitles aren't translated yet. Copied because removeUndefined below
    // edits objects in place.
    const lightShow = (_131 = (_130 = config.fields) === null || _130 === void 0 ? void 0 : _130.lightShow) === null || _131 === void 0 ? void 0 : _131.content;
    if ((_132 = lightShow === null || lightShow === void 0 ? void 0 : lightShow.looks) === null || _132 === void 0 ? void 0 : _132.length) {
        fanConfig.lightShow = {
            ...lightShow,
            looks: lightShow.looks.map((look) => ({ ...look })),
        };
    }
    return (0, utils_1.removeUndefined)(fanConfig);
};
exports.generateEventVersion = generateEventVersion;
//# sourceMappingURL=index.js.map